// @ts-check

import React, { Component, Fragment } from "react"
import ReactFilestack from "lazyComponents/ReactFilestack"
import DefineAction from "../../actions/DefineAction"
import { text, keyvaluelist } from "../../attributes/items/primitives"
import DefineProperty from "../../properties/DefineProperty"
import { Button, Input } from "ui"
import { evaluateFormulas } from "../../formulas/evaluate"

/**
 * @augments {Component<BlockTypeProps, {value: string}>}
 */
export default class ImageUploadBlockType extends Component {
    state = {
        value: "",
    }
    clear = () => {
        return new Promise((resolve, reject) => this.setState({ value: "" }, resolve))
    }
    constructor(props) {
        super(props)
        const evaluate = evaluateFormulas(props.context)
        if (props.config.attributes.defaultValue) {
            this.state.value = evaluate(props.config.attributes.defaultValue)
        }
    }

    componentWillReceiveProps(newProps) {
        const evaluate = evaluateFormulas(newProps.context)
        const evaluateOld = evaluateFormulas(this.props.context)
        const newVal = evaluate(newProps.config.attributes.defaultValue)
        const oldVal = evaluateOld(this.props.config.attributes.defaultValue)
        if (oldVal !== newVal) {
            this.setState({ value: newVal })
        }
    }

    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle }) => (
                    <Fragment>
                        <DefineProperty
                            name={attrs.name || this.props.id}
                            description="input value"
                            type="string"
                            value={this.state.value}
                            onPersistedValue={value => this.setState({ value })}
                            tags={["form"]}
                        />

                        <Input
                            style={{ ...computedStyle, width: "calc(100% - 110px)" }}
                            value={this.state.value}
                            onChange={event => {
                                this.setState({ value: event.target.value })
                            }}
                        />
                        <ReactFilestack
                            apikey="Arfn2PRozQ26eRkdQy74Ez"
                            options={{
                                fromSources: [
                                    "local_file_system",
                                    "url",
                                    "webcam",
                                    "imagesearch",
                                    "facebook",
                                    "instagram",
                                    "googledrive",
                                    "dropbox",
                                ],
                                accept: "image/*",
                                maxFiles: 1,
                                storeTo: {
                                    location: "s3",
                                },
                            }}
                            onSuccess={value => {
                                this.setState({ value: value.filesUploaded[0].url })
                            }}
                            render={({ onPick }) => (
                                <Button
                                    padding="small"
                                    style={{ ...computedStyle, width: "100px", marginLeft: 10 }}
                                    onClick={onPick}
                                >
                                    {attrs.text || "Upload"}
                                </Button>
                            )}
                        />

                        <DefineAction name={this.props.id + ": Clear Select"} action={this.clear} />
                    </Fragment>
                )}
            </Wrapper>
        )
    }
}

ImageUploadBlockType.attributes = [
    text({ field: "name", label: "Field Name" }),
    text({ field: "text", label: "Button text" }),
    text({ field: "defaultValue", label: "Starting value" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/form/ImageUploadBlock.js